import React from 'react';
import { classNames, noop } from '@philips-internal/oswald-ui-utils';
function InformationBarSecondaryRow(props) {
    const { children, className, onClick = noop } = props;
    const rowClassName = classNames({
        'c-information-bar__row': true,
        'c-information-bar__row--secondary': true,
        [`${className}`]: Boolean(className),
    });
    return (React.createElement("div", { className: rowClassName, onClick: onClick }, children));
}
export { InformationBarSecondaryRow, };
//# sourceMappingURL=information-bar-secondary-row.js.map